const $inject = [];

const locationIconFilter = () => {
  return (type) => {
    switch (type) {
      case 'Airport':
        return 'ico-flight';
        break;

      case 'RailStation':
        return 'ico-rail';
        break;

      case 'PointOfInterest':
        return 'ico-ic-poi0';
        break;

      case 'Hotel':
        return 'ico-hotel0';
        break;

      default:
        return 'ico-marker';
        break;
    }
  }
};

locationIconFilter.$inject = $inject;

export default locationIconFilter;



// WEBPACK FOOTER //
// ./src/filters/locationIconFilter.js